module.exports = __webpack_public_path__ + "img/neptune.b64325b1.jpg";